import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';
import commonApi from './common'
import indexApi from './index/index';
import loginApi from './login/index';
import companyApi from './company';
import usercenterApi from './usercenter/index';
import itemApi from "./item/index";
import carrierApi from "./carrier/index";
import datasApi from "./datas/index";
import mobileApi from "./mobile/index";
import enterpriseApi from "./enterprise/index";


const $api = Object.assign({},
    commonApi,
	indexApi,
    loginApi,
    commonApi,
    companyApi,
    usercenterApi,
    itemApi,
    carrierApi,
    datasApi,
    mobileApi,
    enterpriseApi
);



export default $api;



// WEBPACK FOOTER //
// ./src/service/index.js